import {Enum} from "~/enums/index";

export default new Enum({
    SELECTED_NONE: "SELECTED_NONE",
    SELECTED_ALL: "SELECTED_ALL",
    SELECTING: "SELECTING",
});
